/*eslint-disable */
import React, { Component } from "react";
import { Pagination } from "semantic-ui-react";
import MultiSelect from "react-multi-select-component";
import cogoToast from 'cogo-toast';
import OrdersHeader from "../../components/orderComponent/ordersHeaders";
import { readOrderDispatcher } from "../../redux/actions/allOrdersAction";
import { connect } from "react-redux";
import ReadAxios from "../../components/axiosComponent/read";
import allAxiosCommonTA from "../../components/axiosComponent/allAxiosCommonTA";
import CreatAxios from "../../components/axiosComponent/create";
import ExportPDF from "../../components/axiosComponent/exportPDF";
import OrderAgGridTable from "../../components/common/orderadGridTable";
import ModalBroadCast from "./modalBroadCast";
import FormikModalAllot from "./modalAllot";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { Grid } from "semantic-ui-react";
import moment from "moment";
import Vehicletyperenderer from "../common/vehicletyperenderer";
import Sourcerender from "../common/sourcerender";
import Destinationrender from "../common/destinationrender";
import BLrender from "../common/bl_no";
import Allotmentrender from "../common/allotmentrender";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import { Dimmer, Loader } from "semantic-ui-react";
import DeliveryReferenceModal from './deliveryReferenceModal';
import ConsigneeModal from './consigneeModal';
import ConsignorModal from './consignorModal';

import SuggestedVendor from './suggestedVendor';
import DispatchLocation from './dispatchLocation';
import CreateAxios from '../axiosComponent/create'
import ReadAxiosRequestAxios from '../axiosComponent/allAxiosCommonRequest'

class Orders extends Component {
  constructor(props) {
    super(props);
    const { t } = props;
    const billingPartyAvail =
      Number(localStorage.getItem("customerNumber")) == 1122 || Number(localStorage.getItem("customerNumber")) == 984 || Number(localStorage.getItem("customerNumber")) == 1167
        || Number(localStorage.getItem("customerNumber")) == 1123 || Number(localStorage.getItem("customerNumber")) == 1077 || Number(localStorage.getItem("customerNumber")) == 1305 ? "notallowed" : "allowed"

    this.state = {
      spinnerLoading: false,
      loadingData: true,
      showstatusloader: false,
      generated_order: false,
      export: false,
      searchValue: "",
      currentPage: 1,
      itemCount: 10,
      itemsPerPage: 10,
      moment_type: Number(localStorage.getItem("customerNumber")) == 1122 ? "import" : "primary",
      status: "",
      payload: {},
      totalItems: null,
      totalPages: null,
      isLoading: false,
      club: false,
      prevProps: [],
      OrderLists: "",
      rowData: [],
      locales: props.locales.local,
      paginationCallbackData: [],
      chunkedRowData: [],
      currentPageData: [],
      selectedRows: [],
      currentPageNumber: -1,
      componentRenderKey: 0,
      vendorPartnerList: [],
      suggestedPartnerID: null,
      billingParty: billingPartyAvail,
      externalAPIexcelDownloadClick: true,
      exportDataFromSearch: null,
      dispatchLocationOption: [],
      responseReceived: false,
      dispatch_locations: []
    };
  }


  componentDidMount() {
    this.getDispatchLocationAPI()
    // this.props.read();
    this.handleOrderAPICall();
    this.getAllVendors()
  }

  getDispatchLocationAPI = () => {
    CreateAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/dispatchLocation`,
    }).then((res) => {
      this.setState({ dispatch_locations: res.data.resultSet })
    })
      .catch((err) => {
        console.log(err);
      });
  }

  handleDispatchLocation = (dispatchLocationID) => {
    const dispatch_locations_array = []

    this.state.dispatch_locations.forEach(element => {
      let temp = {}
      temp.text = element.dispatch_location_name
      temp.key = element.dispatch_location_name
      temp.value = element.id
      dispatch_locations_array.push(temp)
    });
    console.log("dispatch_locations_arraydispatch_locations_arraydispatch_locations_array")
    console.log(dispatch_locations_array)


    this.setState({ dispatchLocationOption: dispatch_locations_array });

    if (dispatchLocationID) {
      let temp = this.state.dispatch_locations.filter((item) => { if (item.id == dispatchLocationID) { return item } })
      return temp?.[0]?.dispatch_location_name
    } else {
      return '-';
    }
  }

  handleOrderAPICall = () => {
    let billingpartbranchIds = localStorage.getItem('billingpartbranchIds');
    let billingpartIds = localStorage.getItem('billingpartIds');
    let branchIds = localStorage.getItem('branchIds');
    let tempbillingpartbranchIds = billingpartbranchIds != null && billingpartbranchIds != undefined != "" && billingpartbranchIds != "" ? billingpartbranchIds.split(',') : [];
    let tempbillingpartIds = billingpartIds != null && billingpartIds != undefined != "" && billingpartIds != "" ? billingpartIds.split(',') : [];
    let tempbranchIds = branchIds != null && branchIds != undefined != "" && branchIds != "" ? branchIds.split(',') : [];
    let payload = { "booking_branch_ids": tempbranchIds, "billing_party_ids": tempbillingpartIds, "billing_party_branch_ids": tempbillingpartbranchIds }
    let data = this.state.exportDataFromSearch;

    if (!data) {
      data = {
        bl_no: "",
        vendor_id: "",
        vehicle_no: "",
        order_reference_no: "",
        delivery_reference_no: "",
        invoice_no: "",
        required_on: "",
        end_required_on: "",
        common_order_number: ""
      }
    }
    this.setState(
      {
        payload: payload
      },
    );
    if (Number(localStorage.getItem("customerNumber")) == 1122) {
      CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${this.state.status}&bl_no=${data.bl_no}&vehicle_no=${data.vehicle_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&start_required_on=${data.required_on}&end_required_on=${data.end_required_on}&invoice_no=${data.invoice_no}&common_order_number=${data.common_order_number}&page=${this.state.currentPage}&limit=${this.state.itemsPerPage}`, payload })
        .then((res) => {
          this.setState(
            {
              loadingData: false,
              showstatusloader: false,
              rowData: res.data.data,
              currentPage: res.data.meta.currentPage,
              itemCount: res.data.meta.itemCount,
              itemsPerPage: res.data.meta.itemsPerPage,
              totalItems: res.data.meta.totalItems,
              totalPages: res.data.meta.totalPages,
            },
          );
        })
        .catch((err) => {
          console.log('err', err);
        });
    } else {
      //with limit for pagination//CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&page=${this.state.currentPage}&limit=${this.state.itemsPerPage}`, payload })
      //without limit for pagination//CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&page=1&limit=`, payload })
      CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${this.state.status}&bl_no=${data.bl_no}&vehicle_no=${data.vehicle_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&start_required_on=${data.required_on}&end_required_on=${data.end_required_on}&invoice_no=${data.invoice_no}&common_order_number=${data.common_order_number}&page=${this.state.currentPage}&limit=${this.state.itemsPerPage}`, payload })
        .then((res) => {
          let dataFoarmation = res.data.data;

          dataFoarmation.forEach(element => {
            element.dispatch_location_abs = this.handleDispatchLocation(element.dispatch_location_id)
          });

          this.setState(
            {
              loadingData: false,
              showstatusloader: false,
              rowData: res.data.data,
              currentPage: res.data.meta.currentPage,
              itemCount: res.data.meta.itemCount,
              itemsPerPage: res.data.meta.itemsPerPage,
              totalItems: res.data.meta.totalItems,
              totalPages: res.data.meta.totalPages,
            },
          );
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  }

  getAllVendors = () => {
    ReadAxios({ url: `transporterMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? this.setState({ vendorPartnerList: [] })
          : this.setVendorsState(res.data.resultSet);
      })
      .catch((err) => this.setState({ vendorPartnerList: [] }));
  };
  setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.transporterName,
        key: item.transporterCode,
        value: item.transporterMasterId,
      };
    });
    this.setState({ vendorPartnerList: result })
    //setVendors(result);
  };

  resetSuggestedPartner = (suggestedPartnerID, suggestedPartnerName, orderID) => {
    if (suggestedPartnerID) {
      this.setState({ suggestedPartnerID: suggestedPartnerID });
      let temp = this.state.rowData;
      let tempArr = temp.map((item, index) => { if (item.vendor_order_id == orderID) { item.suggested_vendor = suggestedPartnerName; item.suggested_vendor_id = suggestedPartnerID; return item } else { return item; } });
      this.setState({ rowData: tempArr })
      this.updateSuggestedPartner(orderID, suggestedPartnerID)
    }
  }

  updateSuggestedPartner = (orderID, suggestedPartnerID) => {
    allAxiosCommonTA({ url: `/orders/${orderID}`, method: "patch", Items: { suggested_vendor_id: suggestedPartnerID } })
      .then((response) => {
        console.log(response)
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  resetDispatchLocation = (suggestedDispatchLocationID, suggestedDispatchLocationName, orderID) => {
    if (suggestedDispatchLocationID) {
      let temp = this.state.rowData;
      let tempArr = temp.map((item, index) => { if (item.vendor_order_id == orderID) { item.dispatch_location_id = suggestedDispatchLocationID; item.dispatch_location_abs = suggestedDispatchLocationName; return item } else { return item; } });
      this.setState({ rowData: tempArr })
      this.updateDispatchLocation(orderID, suggestedDispatchLocationID)
    }
  }

  updateDispatchLocation = (orderID, suggestedDispatchLocationID) => {
    allAxiosCommonTA({ url: `/orders/${orderID}`, method: "patch", Items: { dispatch_location_id: suggestedDispatchLocationID } })
      .then((response) => {
        cogoToast.success("Updated Dispatch Location!!!")
      })
      .catch((err) => {
        console.log("err", err);
        cogoToast.error("Failes To Updated Dispatch Location...")
      });
  }

  OnpaginationChangeCallback = (event) => {
    console.log('p', event);
  }

  onCellClicked = (rowData) => {
    typeof rowData.value != "undefined" && this.onRowEdit(rowData.data);
  };

  onRowEdit = (rowData) => {
    this.props.history.push({
      pathname: "/shipment-details",
      state: { item: { ...rowData } },
      search: `?shipmentId=${rowData.shipment.vendor_shipment_id}&orderId=${rowData.vendor_order_id}`,
    });
  };

  handleSelect = (data) => {
    let selectedRows = data.api.getSelectedRows();
    if (selectedRows.length !== this.state.selectedRows.length) {
      this.setState({ selectedRows });
    }
  };

  handleChange = (data) => {
    this.setState({ searchValue: data });
    this.state.exportDataFromSearch = data;
    const payload = data;
    //CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${this.state.status}&bl_no=${data.bl_no}&vehicle_no=${data.vehicle_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&page=1&limit=${this.state.itemsPerPage}`, payload })
    CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${this.state.status}&page=${this.state.currentPage}&limit=${this.state.itemsPerPage}`, payload })
      .then((res) => {
        if (res.data.data.length != 0) {
          let dataFoarmation = res.data.data;
          dataFoarmation.forEach(element => {
            element.dispatch_location_abs = this.handleDispatchLocation(element.dispatch_location_id)
          });

          this.setState(
            {
              showstatusloader: false,
              rowData: res.data.data,
              loadingData: false,
              showstatusloader: false,
              rowData: res.data.data,
              currentPage: res.data.meta.currentPage,
              itemCount: res.data.meta.itemCount,
              itemsPerPage: res.data.meta.itemsPerPage,
              totalItems: res.data.meta.totalItems,
              totalPages: res.data.meta.totalPages,
            },
          );
        } else {
          this.setState(
            {
              showstatusloader: false,
              rowData: [],
            },
          );
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  exportDataGrid = () => {
    console.log('here');
    this.setState({ export: true });
  }

  checkFilter = (data) => {
    var payload = this.state.payload;
    this.setState(
      {
        moment_type: data
      }
    )
    if (data.length != 0) {
      if (this.state.status.length != 0) {
        console.log('status here');
        CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${data}&status=${this.state.status}&page=${this.state.currentPage}&limit=`, payload })
          .then((res) => {
            if (res.data.data.length != 0) {
              let dataFoarmation = res.data.data;
              dataFoarmation.forEach(element => {
                element.dispatch_location_abs = this.handleDispatchLocation(element.dispatch_location_id)
              });

              this.setState(
                {
                  showstatusloader: false,
                  rowData: res.data.data,
                },
              );
            } else {
              this.setState(
                {
                  showstatusloader: false,
                  rowData: [],
                },
              );
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
      } else {
        console.log('status nothere');
        CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${data}&page=${this.state.currentPage}&limit=`, payload })
          .then((res) => {
            if (res.data.data.length != 0) {
              let dataFoarmation = res.data.data;
              dataFoarmation.forEach(element => {
                element.dispatch_location_abs = this.handleDispatchLocation(element.dispatch_location_id)
              });

              this.setState(
                {
                  showstatusloader: false,
                  rowData: res.data.data,
                },
              );
            } else {
              this.setState(
                {
                  showstatusloader: false,
                  rowData: [],
                },
              );
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
      }
    } else {
      if (this.state.status.length != 0) {
        CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?status=${this.state.status}&page=${this.state.currentPage}&limit=`, payload })
          .then((res) => {
            if (res.data.data.length != 0) {
              this.setState(
                {
                  showstatusloader: false,
                  rowData: res.data.data,
                },
              );
            } else {
              this.setState(
                {
                  showstatusloader: false,
                  rowData: [],
                },
              );
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
      } else {
        CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?page=1&limit=`, payload })
          .then((res) => {
            if (res.data.data.length != 0) {
              this.setState(
                {
                  showstatusloader: false,
                  rowData: res.data.data,
                },
              );
            } else {
              this.setState(
                {
                  showstatusloader: false,
                  rowData: [],
                },
              );
            }
          })
          .catch((err) => {
            console.log('err', err);
          });
      }
    }
  }

  checkStatus = (data) => {
    var payload = this.state.payload;
    var stat = data.toString();
    this.setState(
      {
        status: stat,
      },
    );
    if (data.length == 0) {
      if (this.state.moment_type != 0) {
        CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&page=${this.state.currentPage}&limit=`, payload })
          .then((res) => {
            let dataFoarmation = res.data.data;
            dataFoarmation.forEach(element => {
              element.dispatch_location_abs = this.handleDispatchLocation(element.dispatch_location_id)
            });

            this.setState(
              {
                showstatusloader: false,
                rowData: res.data.data,
              },
            );
          })
          .catch((err) => {
            console.log('err', err);
          });
      } else {
        CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?page=1&limit=`, payload })
          .then((res) => {
            this.setState(
              {
                showstatusloader: false,
                rowData: res.data.data,
              },
            );
          })
          .catch((err) => {
            console.log('err', err);
          });
      }

    } else {
      if (this.state.moment_type != 0) {
        CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${stat}&page=${this.state.currentPage}&limit=`, payload })
          .then((res) => {
            console.log('stat', res.data);
            if (res.data.data.length != 0) {
              let dataFoarmation = res.data.data;
              dataFoarmation.forEach(element => {
                element.dispatch_location_abs = this.handleDispatchLocation(element.dispatch_location_id)
              });

              this.setState(
                {
                  showstatusloader: false,
                  rowData: res.data.data,
                },
              );
            } else {
              this.setState(
                {
                  showstatusloader: false,
                  rowData: [],
                },
              );
            }

            console.log(this.state.rowData.length);

          })
          .catch((err) => {
            console.log('err', err);
          });
      } else {
        CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?status=${stat}&page=${this.state.currentPage}&limit=`, payload })
          .then((res) => {
            console.log('stat', res.data);
            if (res.data.data.length != 0) {
              this.setState(
                {
                  showstatusloader: false,
                  rowData: res.data.data,
                },
              );
            } else {
              this.setState(
                {
                  showstatusloader: false,
                  rowData: [],
                },
              );
            }

            console.log(this.state.rowData.length);

          })
          .catch((err) => {
            console.log('err', err);
          });
      }

    }

  }

  handlePaginationChange = (e, { activePage }) => {
    console.log(activePage)
    let payload = this.state.payload;
    this.setState(
      {
        loadingData: true,
        showstatusloader: true,
        currentPage: activePage,
        rowData: []
      }, () => {
        this.handleOrderAPICall();
      }
    );
  }


  externalAPIexcelDownload = (data) => {
    this.setState({ spinnerLoading: true })
    // alert('download');
    let payload = {
      bl_no: this.state?.exportDataFromSearch?.bl_no ? this.state.exportDataFromSearch.bl_no : "",
      vendor_id: this.state?.exportDataFromSearch?.vendor_id ? this.state.exportDataFromSearch.vendor_id : "",
      vehicle_no: this.state?.exportDataFromSearch?.vehicle_no ? this.state.exportDataFromSearch.vehicle_no : "",
      order_reference_no: this.state?.exportDataFromSearch?.order_reference_no ? this.state.exportDataFromSearch.order_reference_no : "",
      common_order_number: this.state?.exportDataFromSearch?.common_order_number ? this.state.exportDataFromSearch.common_order_number : "",
      delivery_reference_no: this.state?.exportDataFromSearch?.delivery_reference_no ? this.state.exportDataFromSearch.delivery_reference_no : "",
      required_on: this.state?.exportDataFromSearch?.required_on ? this.state.exportDataFromSearch.required_on : "",
      end_required_on: this.state?.exportDataFromSearch?.end_required_on ? this.state.exportDataFromSearch.end_required_on : "",
      invoice_no: this.state?.exportDataFromSearch?.invoice_no ? this.state.exportDataFromSearch.invoice_no : "",
      route_id: this.state?.exportDataFromSearch?.route_id
        ? this.state.exportDataFromSearch.route_id
        : "",
      consignor_id: this.state?.exportDataFromSearch?.consignor_id
        ? this.state.exportDataFromSearch.consignor_id
        : "",
      consignee_id: this.state?.exportDataFromSearch?.consignee_id
        ? this.state.exportDataFromSearch.consignee_id
        : "",
    }
    let billingPartyBranchIds = localStorage.getItem('billingpartbranchIds').length > 0 ? JSON.stringify(localStorage.getItem('billingpartbranchIds').toString()) : "";
    let bookingBranchIds = localStorage.getItem('branchIds').length > 0 ? JSON.stringify(localStorage.getItem('branchIds').toString()) : "";

    console.log(billingPartyBranchIds)
    console.log(bookingBranchIds)


    if (data === "full") {
      ReadAxiosRequestAxios({
        url: `${process.env.REACT_APP_TA_API_URL}/orders/excel/export?movement_type=${this.state.moment_type}&bl_no=${payload.bl_no}&vendor_name=${payload.vendor_name}&vehicle_no=${payload.vehicle_no}&delivery_reference_no=${payload.delivery_reference_no}&start_required_on=${payload.required_on}&end_required_on=${payload.end_required_on}&order_reference_no=${payload.order_reference_no}&invoice_no=${payload.invoice_no}&common_order_number=${payload.common_order_number}&booking_branch_ids=${bookingBranchIds}&billing_party_branch_ids=${billingPartyBranchIds}&route_id=${payload.route_id}&consignor_id=${payload.consignor_id}&consignee_id=${payload.consignee_id}&export_type=${data}&`,
        method: "get",
        noQ: true
      })
        .then((res) => {
          cogoToast.success(res.data.message);
          console.log(res, "res")
          if (res?.status == 200) {
            this.setState({ responseReceived: true })
          }
          this.setState({ spinnerLoading: false })
        })
        .catch((err) => {
          if (err?.response?.data?.message)
            cogoToast.error(err.response.data.message);
          else
            cogoToast.error("Error While Demapping invoice.");
          this.setState({ spinnerLoading: false })
          console.log("err", err);
        });
    }

  }

  handleMetaSearch = (data) => {
    this.state.exportDataFromSearch = data;
    const payload = data;
    CreatAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders?movement_type=${this.state.moment_type}&status=${this.state.status}&bl_no=${data.bl_no}&vehicle_no=${data.vehicle_no}&vendor_id=${data.vendor_id}&order_reference_no=${data.order_reference_no}&delivery_reference_no=${data.delivery_reference_no}&start_required_on=${data.required_on}&end_required_on=${data.end_required_on}&invoice_no=${data.invoice_no}&common_order_number=${data.common_order_number}&page=${this.state.currentPage}&limit=${this.state.itemsPerPage}`, payload })
      .then((res) => {
        if (res.data.data.length != 0) {
          let dataFoarmation = res.data.data;
          dataFoarmation.forEach(element => {
            element.dispatch_location_abs = this.handleDispatchLocation(element.dispatch_location_id)
          });

          this.setState(
            {
              showstatusloader: false,
              rowData: res.data.data,
              loadingData: false,
              showstatusloader: false,
              rowData: res.data.data,
              currentPage: res.data.meta.currentPage,
              itemCount: res.data.meta.itemCount,
              itemsPerPage: res.data.meta.itemsPerPage,
              totalItems: res.data.meta.totalItems,
              totalPages: res.data.meta.totalPages,
            },
          );
        } else {
          this.setState(
            {
              showstatusloader: false,
              rowData: [],
            },
          );
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  }


  render() {
    const { t } = this.props;
    const customerNo = localStorage.getItem("customerNumber");
    const allocationAccess = [1158].includes(Number(customerNo));

    const {
      rowData,
      generated_order,
      OrderLists,
    } = this.state;

    if (this.state.moment_type == "primary" && Number(localStorage.getItem("customerNumber")) != 1122) {
      var columnDefs = [
        {
          headerName: t("table_view.reference_no") || "Refrence No",
          field: "order_reference_no",
          sortable: true,
          filter: true,
          headerCheckboxSelection: true,
          checkboxSelection: (params) => {
            if (params.data.allotment_status.allotment_text === "Created")
              return true
            else
              return false
          },
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: (params) => {
            if (params.data.allotment_status) {

              if (params.data.allotment_status.allotment_code == 'ALLOC' || params.data.allotment_status.allotment_code == 'ACK' || params.data.allotment_status.allotment_code == 'COMPLETE')
                return false
              else if (params.data.allotment_status.allotment_text === "Created")
                return true
            }
            else {
              return true
            }
          },
          cellClass: params => {
            return (params?.data?.allotment_status?.allotment_code == 'ALLOC' || params?.data?.allotment_status?.allotment_code == 'ACK' || params?.data?.allotment_status?.allotment_code == 'COMPLETE' || params.data.allotment_status.allotment_text !== "Created") ? 'padding-left-40' : 'padding-left-0';
          },
          // checkboxSelection : true,
          tooltipField: "order_reference_no",
          enableRowGroup: true,
          enablePivot: true,
          // width: 200,
        },
        {
          headerName: t("table_view.delivery_reference_no") || "Delivery Reference No.",
          field: "delivery_reference_numbers",
          cellRenderer: "DeliveryReferenceModal",
          //tooltipField: "delivery_reference_numbers",
          width: 100,
          /* minWidth: 150,
          maxWidth: 200, */
          /* suppressSizeToFit: true, */
          resizable: true,
          sortable: true,
          filter: true,
          hide: localStorage.getItem("customerNumber") == 1123 ? false : true
        },
        {
          headerName: t("table_view.suggested_vendor") || "Suggested Vendor",
          field: "suggested_vendor",
          sortable: true,
          filter: true,
          cellRenderer: 'SuggestedVendor',
          hide: localStorage.getItem("customerNumber") == 1123 ? false : true
        },

        {
          headerName: t("table_view.order_no") || "Order Number",
          field: "common_order_number", // source
          sortable: true,
          filter: true,
          tooltipField: "common_order_number",
        },

        {
          headerName: t("table_view.booking_number") || "Booking Number",
          field: "booking_number", // source
          sortable: true,
          filter: true,
          tooltipField: "booking_number",
        },
        {
          headerName: t("table_view.dispatch_location") || "Dispatch Location",
          field: "dispatch_location_abs",
          sortable: true,
          filter: true,
          cellRenderer: 'DispatchLocation',
          hide: localStorage.getItem("customerNumber") == 1123 ? false : true
        },
        {
          headerName: t("table_view.status") || "Status",
          field: "allotment_status.allotment_text" || "Created", // vehicle_type
          sortable: true,
          tooltipField: "allotment_status.allotment_text",
          cellRenderer: "allotment",
          filter: true,
        },
        {
          headerName: t("table_view.remarks") || "Remarks",
          field: "remarks", // source
          sortable: true,
          tooltipField: "remarks",
          filter: true,
        },
        {
          headerName: t("table_view.source") || "Source",
          field: "source", // source
          cellRenderer: "sourcerender",
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.destination") || "Destination",
          field: "checkPointName", // destination
          cellRenderer: "destinationrender",
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.bl_no") || "Bl Number",
          field: "bl_numbers", // destination
          // cellRenderer: "blrender",
          // getQuickFilterText: function (params) {
          //   console.log(params);
          //   // return params.value.name;
          // },
          tooltipField: "data",
          sortable: true,
          filter: true,
          hide: true,
        },
        {
          headerName: t("table_view.consignor_primary") || "Consignor",
          field: "deliveryConsignor",
          cellRenderer: "ConsignorModal",
          width: 100,
          resizable: true,
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.consignee_primary") || "Consignee",
          field: "deliveryConsignee",
          cellRenderer: "ConsigneeModal",
          width: 100,
          resizable: true,
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.container_number") || "Container Number",
          field: "container_no",
          sortable: true,
          tooltipField: "container_no",
          filter: true,
          hide: true,
        },
        {
          headerName: t("table_view.vehicle_type") || "Vehicle Type",
          field: "vehicle_type", // vehicle_type
          sortable: true,
          cellRenderer: "vehicletyperenderer",
          filter: true,
          Width: '190px'
        },
        {
          headerName: localStorage.getItem("customerNumber") != 1158 ? t("table_view.vendor_name") : t("table_view.partner_name") || "Vendor",
          field: "vendor_name",
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.gross_weight") || "Gross Weight",
          field: "gross_weight",
          tooltipField: "gross_weight",
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.movement_type") || "Moment Type",
          field: "shipment.movement_type",
          sortable: true,
          tooltipField: "shipment.movement_type",
          filter: true,
        },
        {
          headerName: t("table_view.shipment_cancel_reason") || "Cancellation Reason",
          field: "shipment.shipment_cancel_reason",
          sortable: true,
          tooltipField: "shipment.shipment_cancel_reason",
          filter: true,
        },
        {
          headerName: t("table_view.required_on") || "Required On",
          field: "shipment.required_on",
          sortable: true,
          filter: true,
          valueFormatter: function (params) {
            return moment(params.value).format("DD-MM-yyyy");
          },
        },
        {
          headerName: t("table_view.created_on") || "Created On",
          field: "created_on",
          sortable: true,
          filter: true,
          valueFormatter: function (params) {
            return moment(params.value).format("DD-MM-yyyy");
          },
        },
        {
          headerName: t("table_view.created_by") || "Created By",
          field: "created_by",
          sortable: true,
          filter: true,
        },

      ];
    } else {
      var columnDefs = [
        {
          headerName: t("table_view.reference_no") || "Refrence No",
          field: "order_reference_no",
          sortable: true,
          filter: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: (params) => {
            if (params.data.allotment_status) {
              if (params.data.allotment_status.allotment_code == 'ALLOC' || params.data.allotment_status.allotment_code == 'ACK' || params.data.allotment_status.allotment_code == 'COMPLETE')
                return false
              else
                return true
            }
            else {
              return true
            }
          },
          // checkboxSelection : true,
          tooltipField: "order_reference_no",
          enableRowGroup: true,
          enablePivot: true,
          // width: 200,
        },
        {
          headerName: t("table_view.delivery_reference_no") || "Delivery Reference No.",
          field: "delivery_reference_numbers",
          cellRenderer: "DeliveryReferenceModal",
          //tooltipField: "delivery_reference_numbers",
          width: 200,
          /*  minWidth: 150,
           maxWidth: 200, */
          /* suppressSizeToFit: true, */
          resizable: true,
          sortable: true,
          filter: true,
          hide: localStorage.getItem("customerNumber") == 1123 ? false : true
        },
        {
          headerName: t("table_view.order_no") || "Order Number",
          field: "common_order_number", // source
          sortable: true,
          filter: true,
          tooltipField: "common_order_number",
        },
        {
          headerName: t("table_view.booking_number") || "Booking Number",
          field: "booking_number", // source
          sortable: true,
          filter: true,
          tooltipField: "booking_number",
        },
        {
          headerName: t("table_view.dispatch_location") || "Dispatch Location",
          field: "dispatch_location_abs",
          sortable: true,
          filter: true,
          hide: localStorage.getItem("customerNumber") == 1123 ? false : true
        },
        {
          headerName: t("table_view.status") || "Status",
          field: "allotment_status.allotment_text" || "Created", // vehicle_type
          sortable: true,
          tooltipField: "allotment_status.allotment_text",
          cellRenderer: "allotment",
          filter: true,
        },
        {
          headerName: t("table_view.remarks") || "Remarks",
          field: "remarks", // source
          sortable: true,
          tooltipField: "remarks",
          filter: true,
        },
        {
          headerName: t("table_view.source") || "Source",
          field: "source", // source
          cellRenderer: "sourcerender",
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.destination") || "Destination",
          field: "checkPointName", // destination
          cellRenderer: "destinationrender",
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.bl_no") || "Bl Number",
          field: "bl_numbers", // destination
          // cellRenderer: "blrender",
          // getQuickFilterText: function (params) {
          //   console.log(params);
          //   // return params.value.name;
          // },
          tooltipField: "data",
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.consignor_import") || "Port terminal",
          field: "deliveryConsignor",
          cellRenderer: "ConsignorModal",
          width: 100,
          resizable: true,
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.consignee_import") || "Delivery Location",
          field: "deliveryConsignee",
          cellRenderer: "ConsigneeModal",
          width: 100,
          resizable: true,
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.container_number") || "Container Number",
          field: "container_no",
          sortable: true,
          tooltipField: "container_no",
          filter: true,

        },
        {
          headerName: t("table_view.vehicle_type") || "Vehicle Type",
          field: "vehicle_type", // vehicle_type
          sortable: true,
          cellRenderer: "vehicletyperenderer",
          filter: true,
          Width: '190px'
        },
        {
          headerName: localStorage.getItem("customerNumber") != 1158 ? t("table_view.vendor_name") : t("table_view.partner_name") || "Vendor",
          field: "vendor_name",
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.suggested_vendor") || "Sugested Vendor",
          field: "suggested_vendor",
          cellRenderer: 'SuggestedVendor',
          sortable: true,
          filter: true,
          hide: localStorage.getItem("customerNumber") == 1123 ? false : true
        },
        {
          headerName: t("table_view.gross_weight") || "Gross Weight",
          field: "gross_weight",
          tooltipField: "gross_weight",
          sortable: true,
          filter: true,
        },
        {
          headerName: t("table_view.movement_type") || "Moment Type",
          field: "shipment.movement_type",
          sortable: true,
          tooltipField: "shipment.movement_type",
          filter: true,
        },
        {
          headerName: t("table_view.shipment_cancel_reason") || "Cancellation Reason",
          field: "shipment.shipment_cancel_reason",
          sortable: true,
          tooltipField: "shipment.shipment_cancel_reason",
          filter: true,
        },
        {
          headerName: t("table_view.required_on") || "Required On",
          field: "shipment.required_on",
          sortable: true,
          filter: true,
          valueFormatter: function (params) {
            return moment(params.value).format("DD-MM-yyyy");
          },
        },
        {
          headerName: t("table_view.created_on") || "Created On",
          field: "created_on",
          sortable: true,
          filter: true,
          valueFormatter: function (params) {
            return moment(params.value).format("DD-MM-yyyy");
          },
        },
        {
          headerName: t("table_view.created_by") || "Created By",
          field: "created_by",
          sortable: true,
          filter: true,
        },
      ];
    }

    var frameworkcomponent = {
      vehicletyperenderer: Vehicletyperenderer,
      sourcerender: Sourcerender,
      destinationrender: Destinationrender,
      blrender: BLrender,
      DeliveryReferenceModal: DeliveryReferenceModal,
      allotment: Allotmentrender,
      SuggestedVendor: SuggestedVendor,
      DispatchLocation: DispatchLocation,
      ConsigneeModal: ConsigneeModal,
      ConsignorModal: ConsignorModal
    }

    let rowValue = []
    rowData && rowData.forEach((object, index) => {
      let temp = {}
      temp = rowData[index]
      let allotment_text = { allotment_text: "Created" }
      let shipment_cancel_reason = "NA"
      let movement_type = { movement_type: "NA" }
      let required_on = { required_on: "NA" }

      temp.order_reference_no = object?.order_reference_no || "NA"
      temp.common_order_number = object?.common_order_number || "NA"
      temp.booking_number = object?.booking_number || "NA"
      temp.delivery_reference_numbers = object?.delivery_reference_numbers || "NA"
      temp.allotment_status = object?.allotment_status?.allotment_text ? object?.allotment_status : allotment_text
      temp.source = object?.source || "NA"
      temp.checkPointName = object?.checkPointName || "NA"
      temp.bl_numbers = object?.bl_numbers || "NA"
      temp.remarks = object?.remarks || "-"
      temp.container_no = object?.container_no || "NA"
      temp.vehicle_type = object?.vehicle_type || "NA"
      temp.vendor_name = object?.vendor_name || "NA"
      temp.suggested_vendor = object?.suggested_vendor || "NA"
      temp.gross_weight = object?.gross_weight || "NA"
      temp.shipment.shipment_cancel_reason = object?.shipment?.shipment_cancel_reason || shipment_cancel_reason
      /* temp.shipment = object?.shipment?.movement_type || movement_type
      temp.shipment = object?.shipment?.required_on || required_on */
      temp.created_on = object?.created_on || "NA"
      temp.created_by = object?.created_by || "NA"

      let deliveryConsignor = [], deliveryConsignee = [];
      object.deliveries.forEach(element => {
        deliveryConsignor.push(element.consignorName)
        deliveryConsignee.push(element.consigneeName)
      });

      temp.deliveryConsignor = deliveryConsignor;
      temp.deliveryConsignee = deliveryConsignee;

      rowValue[index] = temp
    })

    return (
      <React.Fragment>
        {/* <OrdersHeader
          title={this.props.title}
          LinkName="/add-shipment"
          handleSearch={this.handleChange}
          // importDataGrid={this.importDataGrid}
          handleStatusChange={this.checkStatus}
          exportHidden={this.props.exportHidden}
          radioToggle={this.props.radioToggle}
          toggleView={this.props.toggleView}
          toggle={this.props.toggle}
          baseURL={this.props.baseURL}
        /> */}
        {this.state.rowData.length != 0 && this.state.loadingData == false ? (
          <>
            {this.state.showstatusloader == true && this.state.rowData.length != 0 ? (
              <>
                <LoadingPlaceholder />
              </>
            ) : (
              <>
                <div className="pb-5">
                  {/* <OrderAgGridTable
                    toggleView={this.props.toggleView}
                    title={this.props.title}
                    columnDefs={columnDefs}
                    pagination={true}
                    titleBarTitle="Delivery Plan"
                    baseURL={"orders"}
                    extracomponents={frameworkcomponent}
                    rowData={rowData}
                    exportDataGrid={this.props.exportDataGrid}
                    checkStatus={this.checkStatus}
                    checkFilter={this.checkFilter}
                    handleSearch={this.state.searchValue}
                    suppressRowClickSelection={true}
                    enableCellChangeFlash={true}
                    loading={this.state.loadingData}
                    keyIndex={"u_id"}
                    onEdit={this.onRowEdit}
                    cellDoubleClicked={this.onCellClicked}
                    onSelectionChanged={this.handleSelect}
                    defaultSelectedRows={this.state.selectedRows}
                    currentPageNumber={this.state.currentPageNumber}
                    OnpaginationChangeCallback={this.OnpaginationChangeCallback}
                    vendorPartnerList={this.state.vendorPartnerList}
                    resetSuggestedPartner={this.resetSuggestedPartner}
                    externalAPIexcelDownloadClick={this.state.externalAPIexcelDownloadClick}
                    externalAPIexcelDownload={this.externalAPIexcelDownload}
                    handleMetaSearchCall={this.handleMetaSearch}
                  />
                </div> */}
                  <OrderAgGridTable
                    hideImport={localStorage.getItem("customerNumber") == 1158 ? true : false}
                    showOrderFilterTop={true}
                    showSearchFalse={false}
                    hideNew={allocationAccess}
                    isLoading={this.state.spinnerLoading}
                    toggleView={this.props.toggleView}
                    title={this.props.title}
                    columnDefs={columnDefs}
                    pagination={false}
                    titleBarTitle="Delivery Plan"
                    baseURL={"orders"}
                    extracomponents={frameworkcomponent}
                    //rowData={rowData}
                    rowData={rowValue}
                    exportDataGrid={this.props.exportDataGrid}
                    handleChange={this.handleChange}
                    checkStatus={this.checkStatus}
                    checkFilter={this.checkFilter}
                    handleMetaSearchCall={this.handleMetaSearch}
                    handleSearch={this.state.searchValue}
                    suppressRowClickSelection={true}
                    enableCellChangeFlash={true}
                    loading={this.state.loadingData}
                    keyIndex={"u_id"}
                    onEdit={this.onRowEdit}
                    cellDoubleClicked={this.onCellClicked}
                    onSelectionChanged={this.handleSelect}
                    defaultSelectedRows={this.state.selectedRows}
                    currentPageNumber={this.state.currentPageNumber}
                    OnpaginationChangeCallback={this.OnpaginationChangeCallback}
                    vendorPartnerList={this.state.vendorPartnerList}
                    dispatchLocationOption={this.state.dispatchLocationOption}
                    resetSuggestedPartner={this.resetSuggestedPartner}
                    resetDispatchLocation={this.resetDispatchLocation}
                    externalAPIexcelDownloadClick={this.state.externalAPIexcelDownloadClick}
                    externalAPIexcelDownload={this.externalAPIexcelDownload}
                    responseReceived={this.state.responseReceived}

                  />
                </div>
                <div className="life-cycle w3-white ui pagination menu"
                  style={this.state.selectedRows.length > 0 ?
                    { marginBottom: "50px", } :
                    {}
                  }>
                  <Pagination
                    defaultActivePage={this.state.currentPage}
                    firstItem={null}
                    lastItem={null}
                    onPageChange={this.handlePaginationChange}
                    pointing
                    secondary
                    totalPages={this.state.totalPages}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <>
            {this.state.rowData.length == 0 && this.state.loadingData == false ? (
              <>
                <div className="pb-5">
                  <OrderAgGridTable
                    toggleView={this.props.toggleView}
                    title={this.props.title}
                    columnDefs={columnDefs}
                    pagination={true}
                    showSearchFalse={false}
                    titleBarTitle="Delivery Plan"
                    baseURL={"orders"}
                    extracomponents={frameworkcomponent}
                    rowData={rowData}
                    exportDataGrid={this.props.exportDataGrid}
                    handleChange={this.handleChange}
                    checkStatus={this.checkStatus}
                    checkFilter={this.checkFilter}
                    handleMetaSearchCall={this.handleMetaSearch}
                    handleSearch={this.state.searchValue}
                    suppressRowClickSelection={true}
                    enableCellChangeFlash={true}
                    loading={this.state.loadingData}
                    keyIndex={"u_id"}
                    onEdit={this.onRowEdit}
                    cellDoubleClicked={this.onCellClicked}
                    onSelectionChanged={this.handleSelect}
                    defaultSelectedRows={this.state.selectedRows}
                    currentPageNumber={this.state.currentPageNumber}
                    OnpaginationChangeCallback={this.OnpaginationChangeCallback}
                    vendorPartnerList={this.state.vendorPartnerList}
                    resetSuggestedPartner={this.resetSuggestedPartner}
                    resetDispatchLocation={this.resetDispatchLocation}
                    responseReceived={this.state.responseReceived}
                  />
                </div>
              </>
            ) : (
              <div className="mt-4">
                <OrdersHeader title={t("title") || "Orders"}
                  showSearchFalse={false}
                  responseReceived={this.state.responseReceived}
                  loading={this.state.loadingData}
                />
                <LoadingPlaceholder />
              </div>
            )}
          </>
        )}


        {this.props.auth.role == "Quality Control" ? (null) :
          (
            <>
              {this.state.selectedRows.length > 0 ? (
                <div className="life-cycle w3-white p-2">
                  <Grid columns={2} className="ml-2">
                    <Grid.Row>
                      <Grid.Column width={1} className="mr-4">
                        <ModalBroadCast
                          orders={this.state.selectedRows}
                          reFetchOrder={this.reloadCurrentPage}
                          shipmentId={this.props.shipmentId}
                          role={this.props.auth.role}
                        />
                      </Grid.Column>
                      <Grid.Column width={1}>
                        <FormikModalAllot
                          order={this.state.selectedRows}
                          role={this.props.auth.role}
                          billingParty={this.state.billingParty}
                        // reFetchOrder={this.fetchOrderDetails}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </div>
              ) : null}
            </>
          )}

      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ allorders, locales, permissions, auth }) => {
  return {
    allorders,
    auth,
    permissions,
    locales,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    read: () => dispatch(readOrderDispatcher()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("orders")(Orders));
